export const PaymentRedirectSuccess = () => {
    return <p className='w-full text-center font-semibold pt-3 text-[#00AB43]'>Η πληρωμή ολοκληρώθηκε με επιτυχία.</p>
}

export const PaymentRedirectFailure = () => {
    return <p className='w-full text-center font-semibold pt-3 text-primary'>Η πληρωμή δεν ολοκληρώθηκε.</p>
}